import React from 'react';
import { isList } from '../../hoc';
import { HouseCard } from './HouseCard';

const Wrapper = ({ children }) => (<>{children}</>);

export default isList(Wrapper)(HouseCard);